/**
 * @generated SignedSource<<e27aa6ef0eb2c15954d2ee30f226c89a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendMilestoneToJiraInput = {
  id?: string | null;
  customFields?: ReadonlyArray<JiraCustomFieldInputType | null> | null;
  jiraProjectId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type JiraCustomFieldInputType = {
  key?: string | null;
  value?: string | null;
};
export type sendMilestoneToJiraMutation$variables = {
  input: SendMilestoneToJiraInput;
};
export type sendMilestoneToJiraMutation$data = {
  readonly sendMilestoneToJira: {
    readonly phase: {
      readonly id: string;
      readonly name: string | null;
      readonly jiraId: string | null;
    } | null;
  } | null;
};
export type sendMilestoneToJiraMutation = {
  variables: sendMilestoneToJiraMutation$variables;
  response: sendMilestoneToJiraMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendMilestoneToJiraPayload",
    "kind": "LinkedField",
    "name": "sendMilestoneToJira",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhaseType",
        "kind": "LinkedField",
        "name": "phase",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jiraId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendMilestoneToJiraMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendMilestoneToJiraMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9a281939f571eea3c03633b36038948f",
    "id": null,
    "metadata": {},
    "name": "sendMilestoneToJiraMutation",
    "operationKind": "mutation",
    "text": "mutation sendMilestoneToJiraMutation(\n  $input: SendMilestoneToJiraInput!\n) {\n  sendMilestoneToJira(input: $input) {\n    phase {\n      id\n      name\n      jiraId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "adede70e0d190e6558bcd85fce3a4991";

export default node;
